import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { TOI_DOMAIN } from 'constants/index.js';
import jsonp from 'jsonp';
// import ETNewsLetterSubscriptionModal from './ETNewsLetterSubscriptionModal';
import LoadableComponentLoader from 'components_v2/common/LoadableComponentLoader/LoadableComponentLoader';
import s from './ETNewsLetterSubscriptionModal.scss';

const defaultNLType = 'tv';
const defaultNLId = '1018';

const ETNewsLetter = props => {
  //   1006 : entertainment
  //   1018 : TV
  //   1004: Lifestyle ( not food )

  const { userData, item, isPerpetual, className } = props;

  if (isPerpetual) {
    return null;
  }

  const NLType = item && item.NLType ? item.NLType : defaultNLType;
  const NLId = item && item.NLId ? item.NLId : defaultNLId;

  const apis = {
    subscribe:
      'https://timesofindia.indiatimes.com/newsletter/addsubscription/',
    getsubscription:
      'https://timesofindia.indiatimes.com/newsletter/getsubscription/',
  };

  const [isVisible, setIsVisible] = useState(false);
  const [isAlreadySubscribed, setIsAlreadySubscribed] = useState(false);

  const [showSubscriptionModal, setShowSubscriptionModal] = useState(false);
  const [showModalSuccessMessage, setShowModalSuccessMessage] = useState(false);

  const [userEmailInput, setUserEmailInput] = useState('');
  const [isValidEmail, setIsEmailValid] = useState(false);
  const [isUserLoggedIn, setIsUserLoggedIn] = useState(false);

  const checkIsAlreadySubscribed = email => {
    jsonp(`${apis.getsubscription}?emailid=${email}`, null, (err, resp) => {
      if (err) {
        console.warn(err);
      } else if (resp) {
        if (resp.Status === 'Success') {
          setIsAlreadySubscribed(true);
        }
        setIsVisible(true);
      }
    });
  };

  const setUserData = email => {
    setUserEmailInput(email);
    setIsEmailValid(true);
    checkIsAlreadySubscribed(email);
    setIsUserLoggedIn(true);
  };

  useEffect(
    () => {
      if (userData && !props.isPerpetual) {
        if (
          userData.isLoggedIn &&
          typeof userData.getEmail === 'function' &&
          !isVisible
        ) {
          setUserData(userData.getEmail());
        } else {
          setIsVisible(true);
        }
      }
    },
    [userData],
  );

  const getSubscriptionText = (fromModal = false) => {
    let text = `${
      fromModal ? 'SUBSCRIBE NOW ' : ''
    }to get the latest news, gossip on your favourite stars & oven-fresh movie reviews from top reviewers right in your inbox.`;
    switch (NLId) {
      case '1018':
        text =
          'Get a weekly dose of all the major happenings in the TV world, right in your inbox every Friday.';
        break;
      case '1004':
        text =
          'Find out about the latest Lifestyle, Fashion & Beauty trends, Relationship tips the buzz on Health & Food.';
        break;
      default:
        break;
    }
    return text;
  };

  const isEmailValid = email => {
    let validemail = true;
    const pattern = new RegExp(
      /^(("[\w-\s]+")|([\w-]+(?:\.[\w-]+)*)|("[\w-\s]+")([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/i,
    );
    if (!pattern.test(email)) {
      validemail = false;
    }
    return validemail;
  };

  const handleInputTextChange = event => {
    const validemail = isEmailValid(event.target.value);
    setUserEmailInput(event.target.value);
    setIsEmailValid(validemail);
  };

  const submitNewsletterSubscription = data => {
    let userEmailQuery = data.userEmail;
    let frequencyQuery = data.frequency;
    let scheduleQuery = data.schedule;
    let dayQuery = data.day;

    let subscribeURL = `${
      apis.subscribe
    }?id=${userEmailQuery}&frequency=${frequencyQuery}&scheduletime=${scheduleQuery}&status=1&day=${dayQuery}&nlid=${NLId}&adHoc=true${
      data.languageId ? `&secId=${data.languageId}` : ''
    }${data.languageName ? `&secName=${data.languageName}` : ''}`;

    if (NLId === '1018') {
      userEmailQuery = userEmailInput;
      frequencyQuery = '2';
      scheduleQuery = '1';
      dayQuery = '6';
      subscribeURL = `${
        apis.subscribe
      }?id=${userEmailQuery}&frequency=${frequencyQuery}&scheduletime=${scheduleQuery}&status=1&day=${dayQuery}&nlid=${NLId}&adHoc=true`;
    }

    jsonp(subscribeURL, null, (err, resp) => {
      if (err) {
        console.warn(err);
      } else if (resp) {
        setShowModalSuccessMessage(true);
        setIsAlreadySubscribed(true);
      }
    });
  };

  const toggleModal = () => {
    setShowSubscriptionModal(!showSubscriptionModal);
  };

  const renderNewsletter = () => (
    <>
      <div className={s.et_newsletter_widget}>
        <>
          {isAlreadySubscribed ? (
            <>
              <h3>Thanks for subscribing.</h3>
              <p>
                Please{' '}
                <a
                  className={s.goto_nlpage}
                  target="_blank"
                  href="https://timesofindia.indiatimes.com/newsletterhome.cms"
                  rel="noreferrer"
                >
                  Click Here
                </a>{' '}
                to subscribe other newsletters that may interest you, and
                you&apos;ll always find stories you want to read in your inbox.
              </p>
            </>
          ) : (
            <>
              <h3>Subscribe Now</h3>
              <div className={s.et_newsletter_content}>
                <p>{getSubscriptionText()}</p>
                <div className={`et_subscription_container_${NLType}`}>
                  {NLId === '1018' ? (
                    <div className="user_email_block">
                      {!isUserLoggedIn && (
                        <input
                          type="text"
                          placeholder="Enter your email"
                          className={s.useremail}
                          onChange={handleInputTextChange}
                          value={userEmailInput}
                        />
                      )}
                      <input
                        type="submit"
                        value="Subscribe"
                        onClick={submitNewsletterSubscription}
                        disabled={!isValidEmail}
                      />
                    </div>
                  ) : (
                    <button
                      className={s.et_subscribe_button}
                      onClick={() => {
                        setShowSubscriptionModal(true);
                      }}
                    >
                      Subscribe
                    </button>
                  )}
                </div>
              </div>
              <div className={s.et_newsletter_privacy}>
                By subscribing to newsletter, you acknowledge our{' '}
                <a
                  href={`${TOI_DOMAIN}privacy-policy/cookiepolicy/86934312.cms`}
                  data-eulink={`${TOI_DOMAIN}privacy-policy/cookiepolicy/80245266.cms`}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  privacy policy
                </a>
              </div>
            </>
          )}
        </>
      </div>
      {showSubscriptionModal && (
        <LoadableComponentLoader
          loadableComponentName="ETNewsLetterSubscriptionModal"
          toggleModal={toggleModal}
          getContentText={getSubscriptionText}
          NLId={NLId}
          NLType={NLType}
          // submitCallback={onSubscribe}
          submitCallback={submitNewsletterSubscription}
          showSuccessMessage={showModalSuccessMessage}
          isUserLoggedIn={isUserLoggedIn}
          userEmail={userEmailInput}
        />
      )}
    </>
  );

  return (
    <div
      className={`${s.maincontainer} ${isVisible ? s.maincontainerblue : ''} ${
        className ? s[className] : ''
      } `}
    >
      {isVisible ? renderNewsletter() : null}
    </div>
  );
};

const mapStateToProps = state => ({
  userData:
    state.login && state.login.userData ? state.login.userData : undefined,
});

export default connect(mapStateToProps)(ETNewsLetter);
